import type { ReactNode } from 'react'
import { Mc1CaseLink } from '../Common/Mc1CaseLink'

export interface OpenInMc1LinkProps {
  // The claim number is the link (per MSD-223 feedback) — clicking it opens the
  // claim's case in MC1.
  claimNumber: string
  caseId: number
  // Link text. Defaults to the claim number.
  label?: ReactNode
  // Tooltip for the enabled link. The "not configured" reasons always win over it.
  tooltip?: string
}

export function OpenInMc1Link({
  claimNumber,
  caseId,
  label,
  tooltip = 'View claim in MC1',
}: Readonly<OpenInMc1LinkProps>) {
  return (
    // #333333 in light mode per the UI/UX mockup; the pane-wide link colour in dark mode.
    <Mc1CaseLink caseId={caseId} tooltip={tooltip} color="var(--header-link-color)">
      {label ?? claimNumber}
    </Mc1CaseLink>
  )
}
